import React from 'react';
import { AuctionMonthlyBudgetCardMap } from '../maps';
import DefaultAuctionMonthlyBudgetCard from './default';

export function AuctionMonthlyBudgetCardModule({ publisher_id, ...props }) {
  const Component =
    AuctionMonthlyBudgetCardMap[String(publisher_id)] || DefaultAuctionMonthlyBudgetCard;

  return <Component {...props} />;
}
